import React from 'react';
import { Link } from 'react-router-dom';
import "./Footer.scss"

const Footer = () => {
    return (
        <footer className="bg-dark text-light pt-4 borde">
            <div className="container">
                <div className="row">
                    {/* Accesos */}
                    <div className="col-md-4 mb-4">
                        <h5 className="mb-3">Accesos</h5>
                        <ul className="list-unstyled mb-0">
                            <li className="mb-2">
                                <Link to="/login/paciente" className="text-light text-decoration-none">
                                    Acceso pacientes
                                </Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/login/profesional" className="text-light text-decoration-none">
                                    Acceso profesionales
                                </Link>
                            </li>
                        </ul>
                    </div>
                    {/* Contacto y redes */}
                    <div className="col-md-4 mb-4">
                        <h5 className="mb-3">Contáctanos</h5>
                        <div className="d-flex gap-3 align-items-center">
                            <a href="https://www.instagram.com/espacioridens/" target="_blank" rel="noopener noreferrer" className="text-light fs-3">
                                <i className="bi bi-instagram"></i>
                            </a>
                            <a href="https://wa.me/543535654321" target="_blank" rel="noopener noreferrer" className="text-light fs-3">
                                <i className="bi bi-whatsapp"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="text-center py-3">
                    <p className="mb-0">© 2026 Cauce - Ridens. Todos los derechos reservados.</p>
                </div>
                    
            </div>
        </footer>
    );
};

export default Footer;
